import React from "react"
import { processMarkdown } from "@/controllers/markdown";

interface MarkdownProps {
    content: string;
    allowHTML?: boolean | undefined;
}

const Markdown: React.FC<MarkdownProps> = ({ content, allowHTML = false }) => (
    <span
        className="markdown"
        dangerouslySetInnerHTML={{
            __html: processMarkdown(content, allowHTML ?? false),
        }}
    ></span>
);

export default Markdown;